import "./index.css";
import useAppData from "../../hooks/useAppData";

const Whatsapp = () => {
	const {settings} = useAppData();
	const rawNumber = settings?.whatsapp_number; 
	const cleanNumber = rawNumber?.replace(/\D/g, "");
	const url = cleanNumber ? `https://wa.me/${cleanNumber}` : "#";
	return (
		<a
			className="whatsapp_icon"
			href={url}
			target="_blank"
			rel="noreferrer"
		>
			<div>
				<p>Hi, How may I help you Today?</p>
			</div>
			<img src="/assets/images/whatsapp.png" alt="" />
		</a>
	);
};

export default Whatsapp;
